import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { browserHistory } from 'react-router';
import { firebaseConnect } from 'react-redux-firebase';
import { AppWelcome } from 'medua-components';
// import { setNotification } from '../../actions/actions';

/* eslint-disable */
@firebaseConnect()
@translate('auth')
export default class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      error: '',
    };
    this.handleLogin = this.handleLogin.bind(this);
  }

  handleLogin(e) {
    e.preventDefault();

    // const email = String(this.state.email);
    const { email, password } = this.state;

    this.props.firebase.auth().signInWithEmailAndPassword(email, password).then(() => {
      browserHistory.push('/');
    }).catch((error) => {
      console.log(error);
      this.setState({ error: error.message });
    });
  }

  render() {
    return (
      <AppWelcome
        login
        title={ String("School").toUpperCase() }
        placeholder={{
          email: this.props.t('auth:login.placeholder.email'),
          password: this.props.t('auth:login.placeholder.password'),
        }}
        text={{
          login: this.props.t('auth:login.text.login'),
          forgot: this.props.t('auth:login.text.forgot'),
        }}
        onSubmit={ this.handleLogin }
        onEmailChange={ (e) => this.setState({ email: e.target.value })}
        onPasswordChange={ (e) => this.setState({ password: e.target.value })}
        error={ this.state.error }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/auth/login/index.jsx